<template>
  <div class="card card-dashboard-twentysix" style="height:360px" v-loading='loading'>
    <div class="card-header mg-b-10">
        <h6 class="card-title">Overview</h6>
        <div class="chart-legend">
        <div><span class="bg-indigo"></span> fund balance</div>
        <div><span class="bg-teal"></span> trend</div>
        </div>
    </div>
    <div class="card-body">
        <div class="pd-10">
            <el-row  type="flex" justify="start">
                <el-col>
                    <span>
                        <h6 style="font-size: 22px;">{{total_value.int}}<small>{{total_value.dec}}</small>&nbsp;</h6>
                    </span>
                </el-col>
                <el-col>
                    <span v-bind:class='{ "tx-success": changedata.change>=0,"tx-danger":changedata.change<0 }'>
                        <small>
                            <i v-bind:class='{ "ion-md-arrow-up": changedata.change>=0,"ion-md-arrow-down":changedata.change<0 }' class="icon"></i> 
                            {{changedata.change+'%'}}
                        </small>
                    </span>
                </el-col>
                <el-col>
                    <div class="btn-group">
                        <button v-for="button in buttongroup" :key="button" v-bind:class="{ active: isclicked===button }" class="btn" @click='isclicked=button'>{{button}}</button>
                    </div>
                </el-col> 
            </el-row>
            <label>
                Estimated Fund Investments – All Funds
                
            </label>
        </div>
            
        <!-- <div class="col-lg-2">
            <h6 style="font-size: 22px;">23</h6>
            <label>SMSFs</label>
        </div>
        <div class="col-lg-2">
            <h6 style="font-size: 22px;">39</h6>
            <label>Members</label>
        </div> -->
        <div class="chart-wrapper">
            <chart-balance v-if="isChartShow" ref="chart" :days="chartdata.days" :values="chartdata.values" :trends="chartdata.trends"/>
        </div>
    </div>
    <Disclaimer style="margin-left:20px" />
  </div>
</template>
<script>
export default {
  name: 'overview',
  components:{
    ChartBalance : ()=>import('../charts/ChartBalance.vue'),
    Disclaimer:()=>import('../elements/Disclaimer.vue')

  },
  props: {
    
  },
  watch:{
     isclicked:function(oldVal,newVal){
         return this.isclicked==='Day'? this.changedata.change = this.changedata.day
               :this.isclicked==='Month'? this.changedata.change = this.changedata.month
               :this.changedata.change = this.changedata.quarter
     }
  },
  data(){
    return{
        chartdata:{
            days:[],
            values:[],
            trends:[],
        },
        isChartShow:false,
        changedata:{
            change:'',
            day:'',
            month:'',
            quarter:'',
        },
        total_value:{
            int: '',
            dec: ''
        },
        isclicked:'Day',
        buttongroup:['Day','Month','Quarter'],
        smsfs:'',
        members:'',
        loading:true,
    }
  },
  created(){
        this.getMarketvalue();
    
  },
  methods:{
        getMarketvalue: function(){
            let brand = localStorage.getItem('brand_code')
            this.$api.adviserdashboard_api.marketValue(brand).then(response =>{
                //get the chartdata from response
                this.chartdata.days = response.data["days"];
                this.chartdata.values = response.data["market_value"];
                let trends = response.data["trend"];
                trends.unshift(0);
                this.chartdata.trends = trends;
                
                //calculate the total value and changes 
                this.getTotalValue();
                this.getChangeData();
                this.initValues();
                this.loading=false
            });

        },
        getLatest(){
            return this.chartdata.values[this.chartdata.values.length-1];
        },
        getTotalValue(){
            let formatter = new Intl.NumberFormat('en-AU', {
                style: 'currency',
                currency: 'AUD',
            });
            let format_value = formatter.format(this.getLatest());
            this.total_value.int = (format_value.split('.'))[0];
            this.total_value.dec = '.'+(format_value.split('.'))[1];
        },
        getChangeData(){
            let value_month_ago = this.chartdata.values[this.chartdata.values.length-30];
            let value_quarter_ago = this.chartdata.values[this.chartdata.values.length-91];
            this.changedata.day = this.chartdata.trends[this.chartdata.trends.length-1]
            this.changedata.month = parseFloat(100 * (this.getLatest() - value_month_ago) / value_month_ago).toFixed(2);
            this.changedata.quarter = parseFloat(100 * (this.getLatest() - value_quarter_ago) / value_quarter_ago).toFixed(2);
            this.changedata.change = this.day;
            
        },
        initValues(){
            this.changedata.change = this.changedata.day;
            this.isChartShow = true;
        }
  }
} 

    
    
  
</script>
<style scoped>
.btn-group{
    float:right;
    padding:2px;
    position: relative;
    display: inline-flex;
    vertical-align: middle;
    font-family: "Roboto", sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #031b4e;
    text-align: left;
    word-wrap: break-word;
    margin-top: 0;
}
.btn{
    font-size: 8px;
    font-weight: 400;
    padding: 3px 8px;
    min-height: inherit;
    background-color: #fff;
    color: #7987a1;
    border: 1px solid #cdd4e0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    position: relative;
    flex: 1 1 auto;
}
.active{
    color: #1c273c;
    background-color: #e3e7ed;
    border-color: #cdd4e0;
    z-index: 1;
}


</style>